<template lang="pug">
.this-is-an-example(v-text="example && 'Hello World'")
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'Example',
    data() {
        return {
            example: true
        }
    },
  };
</script>

<style lang="scss" scoped>
</style>